import React from "react";
import selctContact from "../assets/images/selctContact.svg";
import { useNavigate } from "react-router-dom";

export default function RegSucessful() {
  const navigate = useNavigate();

  const onClickPopup = () => {
    // navigate("/LoginScreen");
    window.location = "/Signin";
  };
  return (
    <div className="mainPage loginPage">
      <div className="successful positioncenter">
        <div className="card  text-center">
          <div className="bluebox">
            <div className="circlemark">
              <img alt="" src={selctContact} />
            </div>
            <h5 className="text-white pt-4 mb-0">UPDATED</h5>
          </div>
          <div className="card-body">
            <p className="card-text">
              Congratulations, your password has been successfully updated.
            </p>

            <button
              type="button"
              onClick={onClickPopup}
              className="btn btn-primary w-100 mt-3"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
